import React from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import templatesAPI from "restApi/templatesApi";

const NONE_OPTION = { id: null, name: "None" };

// Single-select over the team's setlist templates, "None" included as a
// real option (clearing the template is a distinct, valid choice - not
// the same as "nothing selected yet"). Loaded eagerly (not lazily on
// open, unlike SongSelect) so the field can show the event's actual
// current template by name right away, since `value` here is controlled
// rather than SongSelect's uncontrolled defaultValue.
export default ({ value, onChange }) => {
  const [loading, setLoading] = React.useState(true);
  const [options, setOptions] = React.useState([NONE_OPTION]);

  React.useEffect(() => {
    let cancelled = false;
    templatesAPI.getTemplates().then((res) => {
      if (cancelled) return;
      setOptions([NONE_OPTION, ...(res.data || [])]);
      setLoading(false);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  const selected = options.find((option) => option.id === value) || NONE_OPTION;

  return (
    <Autocomplete
      id="templateSelect"
      options={options}
      getOptionLabel={(option) => option.name}
      value={selected}
      disableClearable
      loading={loading}
      onChange={(event, newValue) => onChange(newValue ? newValue.id : null)}
      getOptionSelected={(option, val) => option.id === val.id}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="standard"
          color="secondary"
          label="Setlist template"
        />
      )}
    />
  );
};
